import { render, staticRenderFns } from "./AlertEvent.vue?vue&type=template&id=957327cc"
import script from "./AlertEvent.vue?vue&type=script&lang=js"
export * from "./AlertEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports